import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate, useLocation } from 'react-router-dom';
import ConfigPage from './pages/ConfigPage';
import MultiFileUploadForm from './components/MultiFileUploadForm';
import OutputTabs from './components/OutputTabs';
import LandingPage from './pages/LandingPage';
import Footer from './components/Footer';
import { useAppContext } from './context/AppContext';
import Dashboard from './components/Dashboard';
import Toast from './components/Toast';
import Header from './components/Header';
import LoadingSpinner from './components/LoadingSpinner';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import SignOutButton from './components/SignOutButton';
import { useAuth } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  // Use context for global state
  const {
    currentDocument,
    setCurrentDocument,
    activeTab,
    setActiveTab,
    generationResults,
    setGenerationResults,
    toast,
    showToast,
  } = useAppContext();

  const { currentUser } = useAuth();

  // Example: effect to reset results when document changes
  useEffect(() => {
    setGenerationResults({});
    setActiveTab('mockPaper');
  }, [currentDocument]);

  // Handler for successful upload
  const handleUploadSuccess = (res) => {
    // Use the combined documentId and filenames from the new backend response
    if (res && res.documentId) {
      setCurrentDocument({
        documentId: res.documentId,
        filenames: res.filenames,
      });
    }
  };

  // Initial app loading state
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000); // 1s for demo
    return () => clearTimeout(timer);
  }, []);

  // Helper: redirect authenticated users away from auth pages
  function RedirectIfAuth({ children }) {
    const { currentUser } = useAuth();
    const location = useLocation();
    if (currentUser) {
      return <Navigate to="/app" state={{ from: location }} replace />;
    }
    return children;
  }

  React.useEffect(() => {
    AOS.init({
      duration: 700,
      once: true,
      offset: 60,
      easing: 'ease-out-cubic',
    });
  }, []);

  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-background">
        {/* Toast Notification */}
        {toast.visible && (
          <Toast
            message={toast.message}
            type={toast.type}
            onClose={() => showToast('', toast.type, 0)}
          />
        )}
        {/* NavBar */}
        <Header />
        {/* Main Content */}
        <main className="flex-1 container mx-auto px-6 py-8">
          {loading ? (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--color-bg)] transition-colors">
              <LoadingSpinner size={16} />
            </div>
          ) : (
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/config" element={<ConfigPage />} />
            <Route path="/app" element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } />
            <Route path="/signin" element={
              <RedirectIfAuth>
                <SignIn />
              </RedirectIfAuth>
            } />
            <Route path="/signup" element={
              <RedirectIfAuth>
                <SignUp />
              </RedirectIfAuth>
            } />
          </Routes>
          )}
        </main>
        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App; 